/*
 * Alpha JavaScript Library
 *
 * [What does it do? Dunno, since there's no commment here to explain it.]
 */
const A = {
  /**
   *  Replaces ugly tiny broken image pic with optional replacement or A checkers
   *  <img onerror="A.fixBrokenImg(this)" src="some/rouge/image.png"...>
   */
  fixBrokenImg (img: HTMLImageElement, src: string) {
    var source = src || '/img/icon.png'
    img.onerror = null
    img.src = source
    return true
  },

  /**
   *  Strip out HTML tags from a string entirely
   */
  stripHTML (text?: string): string {
    if (!text) {
      return ''
    }
    const htmlVersion = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    const div = document.createElement('div')
    div.innerHTML = htmlVersion
    const cleaned = div.textContent!.replace(/&nbsp;/g, ' ').trim()
    return cleaned
  },

  /**
   *  Remove non ASCII characters from a string
   */
  stripNonASCII (str: string) {
    if (!str) {
      return ''
    }
    return str
    // return str.replace(/[^\x00-\x7F]/g, '')
  },

  /* check if string is a json object */
  isJsonString (str: any) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },

  // Does a nice clean clone of objects.
  // WILL BREAK FUNCTIONS IN OBJECTS
  clone<T> (obj: T): T {
    if (obj === undefined) {
      return obj
    }
    return JSON.parse(JSON.stringify(obj))
  },

  isValidUrl (url: string) {
    const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(:[0-9]{1,5})?(\/.*)?$/
    return url.trim() && url.trim().match(regex)
  },

  // Returns new string that converts snake/kebab to camel
  toCamel (s: string) {
    return s.replace(/([-_][a-z])/ig, ($1) => {
      return $1.toUpperCase()
        .replace('-', '')
        .replace('_', '')
    })
  }
}

export const trimPrototypeURLs = (protos: any) => {
  for (const key in protos) {
    if (protos[key] && protos[key].url) {
      protos[key].url = protos[key].url.trim()
    }
  }
  return protos
}

export const forceString = (arg: string | number) => {
  if (typeof arg === 'string') {
    return arg
  } else {
    return arg.toString()
  }
}

export default A
